import Vue from 'vue'
import App from './App'
import Index from './layout/IndexLayout'

import VueRouter from 'vue-router'
import VueResource from 'vue-resource'

Vue.use(VueRouter)
Vue.use(VueResource)

Vue.http.options.emulateJSON = true

const router = new VueRouter()

router.map({
  '/': {
    name: 'index',
    component: Index
  },
  '/drops/:title': {
    name: 'drops',
    component: function (resolve) {
      require(['./layout/DropsLayout'], resolve)
    }
  }
})

router.redirect({
  '*': '/'
})

router.start(App, 'app')



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/